export const serverUrl = "https://api.processed.art/"
export const contractAddress = "0x94eDd64585015A3Bb06c6061A70Fb63ef4bC3cEf"
export const ipfsGateway = "http://processedart.mypinata.cloud"
export const cloudflareGateway = "https://cloudflare-ipfs.com"
export const ALCHEMY_URL="https://eth-mainnet.alchemyapi.io/v2/-ObVRu7w03_whaIGRwvYxVF11BOYZcT4";